import type { FormInstance } from '@arco-design/web-react/es/Form';

import { joinPath } from '@/delivery-type-plugin/core/utils';

import type { CommandShellType } from './types';
import type { MaasInitCommandFormFields } from './utils';

/** path 解析用的可选段名（与 capability options 对齐，无 UI 依赖） */
export interface CommandArgsNormalPathOptions {
  shellTypeSegment?: string;
  commandsSegment?: string;
  argsSegment?: string;
}

export type CommandArgsNormalPaths = Record<string, string> & {
  shellType: string;
  commands: string;
  args: string;
};

export function resolveCommandArgsNormalPaths(prefix: string, options?: CommandArgsNormalPathOptions): CommandArgsNormalPaths {
  const shellTypeSegment = options?.shellTypeSegment ?? '_shellType';
  const commandsSegment = options?.commandsSegment ?? '_commandsText';
  const argsSegment = options?.argsSegment ?? '_argsText';
  return {
    shellType: joinPath(prefix, shellTypeSegment),
    commands: joinPath(prefix, commandsSegment),
    args: joinPath(prefix, argsSegment),
  };
}

/** 从表单 paths 读取 initCommand 辅助字段 */
export function readInitCommandFieldsFromForm(form: FormInstance, prefix = 'initCommand'): MaasInitCommandFormFields | undefined {
  const paths = resolveCommandArgsNormalPaths(prefix);
  const shellType = form.getFieldValue(paths.shellType);
  const commandsText = form.getFieldValue(paths.commands);
  const argsText = form.getFieldValue(paths.args);
  if (shellType === undefined && commandsText === undefined && argsText === undefined) {
    return undefined;
  }
  return {
    _shellType: shellType as CommandShellType | undefined,
    _commandsText: commandsText as string | undefined,
    _argsText: argsText as string | undefined,
  };
}
